import { WidgetOutlet } from '@/core/widgets/export';
import ForecastFrenzyTabBar from '@/modules/calendar/components/forecast-game/forecast-frenzy-tab-bar';

export default function ForecastFrenzyLayout() {
  return (
    <div>
      <ForecastFrenzyTabBar />
      <WidgetOutlet />
    </div>
  );
}
